import { Directive, forwardRef, inject, Input } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yBooleanInput, A11yHasPopupValue, A11yLabelTarget } from '../interfaces/a11y.interfaces';
import { normalizeAriaValue } from '../utils/a11y.util';

import { A11yDisclosureDirective } from './a11y-disclosure.directive';
import { A11yExpandableDirective } from './a11y-expandable.directive';

@Directive({
  selector: '[khA11yDisclosureTrigger]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yDisclosureTriggerDirective) }]
})
export class A11yDisclosureTriggerDirective extends A11yExpandableDirective implements A11yLabelTarget {
  private readonly disclosure = inject(A11yDisclosureDirective, { optional: true });

  @Input('khA11yDisclosureTrigger') public isOpen: A11yBooleanInput = null;
  @Input() public khA11yDisclosureControls: string | null = null;
  @Input() public khA11yDisclosureHasPopup: A11yHasPopupValue = null;

  protected override get expandedInput(): A11yBooleanInput {
    return this.disclosure?.isOpen ?? this.isOpen;
  }

  protected override get controlsInput(): string | null {
    return normalizeAriaValue(this.khA11yDisclosureControls) ?? this.disclosure?.getPanelId() ?? null;
  }

  protected override get hasPopupInput(): A11yHasPopupValue {
    return this.khA11yDisclosureHasPopup;
  }
}
